// Mutation types
export const UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE'
export const SET_SESSION = 'SET_SESSION'
export const RESET_STATE = 'RESET_STATE'
